import React from 'react'
import styled from '@emotion/styled'
import { IconProps } from '../../models/IconProps'
const BaseComponent = ({ size = 24, tabIndex = -1, focusable = false, ...props }: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      tabIndex={tabIndex}
      focusable={focusable}
      fill="currentColor"
      {...props}
    >
      <defs>
        <clipPath id="clj1y40ona">
          <path d="M1440 0v1175H0V0h1440z" />
        </clipPath>
        <clipPath id="fmndxu02ob">
          <path d="M9 0a9 9 0 1 1 0 18A9 9 0 0 1 9 0zM6.167 6c-.493 0-.937.078-1.33.233-.395.155-.727.37-.998.643-.27.273-.478.593-.622.96A3.228 3.228 0 0 0 3 9.027c0 .418.072.807.217 1.169.144.361.351.676.622.944.27.267.603.477.997.63a3.66 3.66 0 0 0 1.33.229c.398 0 .762-.054 1.093-.16.33-.108.62-.263.866-.467.246-.203.445-.45.595-.738.15-.29.244-.614.28-.972H7.629c-.055.385-.203.696-.447.931-.244.236-.582.354-1.015.354-.319 0-.59-.055-.812-.165a1.5 1.5 0 0 1-.541-.438 1.801 1.801 0 0 1-.303-.614 2.616 2.616 0 0 1-.094-.703c0-.252.031-.495.094-.73.063-.236.164-.447.303-.631.138-.185.318-.332.54-.442.223-.11.494-.165.813-.165.174 0 .341.026.5.077.16.05.303.121.43.212.126.091.23.197.315.318.084.12.138.253.162.397h1.372a2.134 2.134 0 0 0-.307-.883 2.238 2.238 0 0 0-.618-.647 2.851 2.851 0 0 0-.848-.397A3.616 3.616 0 0 0 6.167 6zm5.297 0H10v6h1.464V9.723c0-.443.09-.76.268-.954.179-.193.467-.29.866-.29.35 0 .594.088.732.265.137.176.206.444.206.802V12H15V9.328c0-.27-.03-.514-.088-.736a1.289 1.289 0 0 0-.304-.563 1.44 1.44 0 0 0-.593-.36c-.25-.088-.572-.131-.963-.131-.275 0-.557.057-.846.172a1.603 1.603 0 0 0-.711.55h-.031V6z" />
        </clipPath>
      </defs>
      <g clipPath="url(#clj1y40ona)" transform="translate(-658 -284)">
        <g clipPath="url(#fmndxu02ob)" transform="translate(661 287)">
          <path fill="currentColor" d="M0 0h18v18H0V0z" />
        </g>
      </g>
    </svg>
  )
}
export default styled(BaseComponent)`
  outline: none;
`
